<template>
  <div class="flex flex-col items-center justify-center min-h-[70vh] text-center p-6">
    <div class="max-w-md w-full">

      <!-- Header Section -->
      <div class="flex items-center justify-between mb-12 w-full">
        <!-- The page title can be dynamically set by the router -->
        <h1 class="text-2xl sm:text-3xl font-bold text-gray-800">{{ $route.meta.title || 'Page Not Found' }}</h1>
        <BackButton />
      </div>

      <!-- Main Content -->
      <div class="mb-4">
        <svg class="mx-auto h-16 w-16 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.472-2.472a3.375 3.375 0 00-4.773-4.773L6.75 5.25l-2.472 2.472a3.375 3.375 0 004.773 4.773z" />
        </svg>
      </div>
      
      <h2 class="text-3xl font-bold text-gray-800">Feature Coming Soon</h2>
      
      <p class="mt-3 text-gray-600">
        This section is currently under construction. We're working hard to bring this feature to you as soon as possible.
      </p>
      
    </div>
  </div>
</template>

<script setup>
// Reusable BackButton is now used
import BackButton from '@/components/BackButton.vue';
</script>

<style scoped>
/* No specific styles needed */
</style>